import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-left-navbar',
  imports: [RouterLink],
  templateUrl: './left-navbar.component.html',
  styleUrl: './left-navbar.component.css'
})
export class LeftNavbarComponent {

}
